import { useMatchedGrantsMetrics } from '@/hooks';
import { Card, Divider, Typography } from '@mui/material';
import React from 'react';
import { SummaryItem } from './SummaryItem';
export const PipelineSummary = () => {
    const { totalAvg, formattedTotalAmount, totalCount } = useMatchedGrantsMetrics();
    return (React.createElement(Card, { sx: {
            pt: 3,
            px: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            background: 'white',
            borderRadius: '16px',
            border: (theme) => `1px solid${theme.palette.grey[200]}`,
        } },
        React.createElement(Typography, { color: "secondary", fontSize: { xs: '1rem', sm: '1.2rem' }, fontWeight: 600 }, "Your Pipeline Summary"),
        React.createElement(SummaryItem, { value: totalCount, label: "Total grants" }),
        React.createElement(Divider, { sx: {
                my: 1,
                width: '100%',
                height: '0.8px',
                background: (theme) => theme.palette.grey[100],
            } }),
        React.createElement(SummaryItem, { value: totalAvg, label: "average per grant" }),
        React.createElement(Divider, { sx: {
                my: 1,
                width: '100%',
                height: '0.8px',
                background: (theme) => theme.palette.grey[100],
            } }),
        React.createElement(SummaryItem, { value: formattedTotalAmount, label: "Total fundings" })));
};
